export default __webpack_public_path__ + "static/media/10c.713e26df.png";